import * as React from 'react';
import { BaseControlProps } from '../../../models/BaseControlProps';
import { Box, Button, LinearProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';


interface ConfirmPromptProps extends BaseControlProps {
    open: boolean;
    title?: string;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
    isLoading: boolean;
}

export default function ConfirmPrompt(props: ConfirmPromptProps) {

    const { open, message, title = 'Please Confirm!', onConfirm, onCancel, isLoading } = props;

    return (
        <Dialog 
            open={open} 
            onClose={onCancel}
            aria-labelledby="confirmation-dialog-title" 
            aria-describedby="confirmation-dialog-description"
        >
            <DialogTitle id="confirmation-dialog-title">
                {title}
                {isLoading &&
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                }
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="confirmation-dialog-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="primary">
                    Cancel
                </Button>
                <Button disabled={isLoading} onClick={onConfirm} color="primary" variant="contained" autoFocus>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
}